import { useLanguageContext } from "../context/LanguageContext";

export default function LoadingComponent() {
  const { t } = useLanguageContext();
  return (
    <>
      <div className="w-10 h-10 rounded-full border-4 border-gray-600 border-t-main_accent animate-spin" />

      <p className="text-gray-400 text-sm">
        {t("joinPage", "formState", "loadingTitle")}
      </p>
    </>
  );
}
